// extracted by mini-css-extract-plugin
export var progress = "homepage-quiz-module--progress--08e84";